import { render } from "./StarField.vue?vue&type=template&id=df272846&scoped=true"
import script from "./StarField.vue?vue&type=script&lang=js"
export * from "./StarField.vue?vue&type=script&lang=js"

import "./StarField.vue?vue&type=style&index=0&id=df272846&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df272846"]])

export default __exports__